export enum RoleType {
  SYSTEM = 'SYSTEM',
  USER = 'USER',
}

export const RoleTypeLabel: Record<RoleType, string> = {
  [RoleType.SYSTEM]: 'Системная',
  [RoleType.USER]: 'Пользовательская',
};

export enum MODULE_TYPE {
  VACCINATION = 'Вакцинация',
  PHARMACY = 'Аптека',
  REPORT = 'Отчетность ',
  ADMINISTRATION = 'Администрирование',
  FARM = 'Хозяйство',
  PATHOLOGY = 'Патологоанатомия',
}
